import React from "react";
import { ConfigurationModes } from "./hcs-constants";
import HcsControl from "./hcs-control";

export default class HcsSubConfigTopMenu extends HcsControl {
    constructor(props) {
        super(props);

        this.state = {
            
        };

        this.buttonClick = this.buttonClick.bind(this);
    }

    buttonClick(event) {
        const { data } = this.props;

        this.props.onConfig("enterSubCfgObject", null, null, {
            subConfigMode: ConfigurationModes.SubConfigurationTopMenu,
            subConfigName: data.ident,
            subConfigDescription: data.info.trans,
            subConfigIndex: 0
        });
    }

    childClass() {
        return "hcs-sub-config-default";
    }

    render() {
        const { data } = this.props;

        return super.render(
            <button
                onClick={this.buttonClick}
            >
                <span dangerouslySetInnerHTML={{ __html: data.info.trans }} />
                <svg icon-id={"icn-001-2-arrow-bold"} version="2.0">
                    <use href={"#icn-001-2-arrow-bold"}></use>
                </svg>
            </button>
        );
    }
}
